module.exports = __webpack_public_path__ + "3153547a6b2749d9de60ccb7f319d2e8.png";